// Public stock pages (backend plan 285): /api/stocks/*. No auth needed except the
// signed link for older reports (axios carries the JWT when signed in).
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = `${API_BASE_URL}/api/stocks`;
const cache = new Map();

async function get(url) {
  if (cache.has(url)) return cache.get(url);
  const p = fetch(url, { headers: { Accept: "application/json" } }).then(async (r) => {
    const body = await r.json().catch(() => ({}));
    if (!r.ok) {
      cache.delete(url);
      const err = new Error(body.error || `HTTP ${r.status}`);
      err.status = r.status;
      err.body = body;
      throw err;
    }
    return body;
  });
  cache.set(url, p);
  p.catch(() => cache.delete(url));
  return p;
}

const seg = (exsym) => encodeURIComponent(exsym).replace(/%3A/gi, ":");

export const searchStocks = (q) => get(`${base}/search/?q=${encodeURIComponent(q)}`);
export const getSummary = (exsym) => get(`${base}/${seg(exsym)}/`);
export const getTab = (exsym, tab, period = "annual") =>
  get(`${base}/${seg(exsym)}/${tab}/${period === "quarterly" ? "?period=quarterly" : ""}`);
export const getReports = (exsym) => get(`${base}/${seg(exsym)}/reports/`);
export const fileUrl = (path) => `${API_BASE_URL}${path}`;

// Older reports: a short-lived signed link for the signed-in user.
export async function signedReportUrl(id) {
  const r = await axios.get(`${base}/reports/${encodeURIComponent(id)}/link/`);
  return `${API_BASE_URL}${r.data.url}`;
}

export const stockPath = (exsym) => `/symbols/${exsym}`;

// Article Excel model (paid accounts): a 5-minute signed link. 401 = sign in, 402 = paid plan needed.
export async function articleXlsxUrl(path) {
  const r = await axios.get(`${API_BASE_URL}/api/research/xlsx/`, { params: { path } });
  return r.data.url;
}
